/* نصوص الموقع بالعربية والإنجليزية / Site copy in Arabic and English */

export const strings = {
  ar: {
    dir: "rtl",
    langLabel: "EN",
    langSwitchAria: "التبديل إلى الإنجليزية",
    skipToContent: "تجاوز إلى المحتوى",
    nav: {
      home: "الرئيسية",
      designs: "التصاميم",
      visualizer: "مجسّم المدخل",
      features: "المزايا والتشطيبات",
      about: "من نحن",
      faq: "الأسئلة الشائعة",
      contact: "تواصل معنا",
      cta: "صمّم مدخلك معنا",
      menuOpen: "فتح القائمة",
      menuClose: "إغلاق القائمة",
    },
    hero: {
      eyebrow: "أبواب بيفوت ألمنيوم",
      title: ["الفخامة", "تبدأ من", "باب دارك."],
      body: "أبواب بيفوت ألمنيوم، بتصاميم تعبّر عن ذوقك، وتشطيبات تنسجم مع واجهتك، وخيارات دخول ذكية لراحة كل يوم.",
      primary: "اختَر تصميم بابك",
      secondary: "شاهد الأبواب بالحركة",
      strip: ["تصنيع حسب الطلب", "تشطيبات متنوعة", "خيارات أقفال ذكية"],
      scroll: "اكتشف",
      imageNote: "من أعمال APEX",
      mute: "كتم صوت الفيديو",
      unmute: "تشغيل صوت الفيديو",
    },
    marquee: "الفخامة تبدأ من باب الدار",
    manifesto: {
      label: "APEX DOORS",
      title: "باب واحد. ينطق بكل البيت.",
      body: "نصنع أبواب بيفوت ألمنيوم حسب الطلب: المقاس، التلبيس، نظام الحركة وطريقة الدخول تُحدَّد لمدخلك وحده. لا كتالوج جاهز، بل باب يُبنى على قياس واجهتك.",
      facts: [
        { k: "ارتفاع الدرفة", v: "٢ – ٩ م" },
        { k: "عرض الدرفة", v: "١.٤٠ – ٢.٥٠ م" },
        { k: "عائلات التشطيب", v: "٤" },
        { k: "التصنيع", v: "حسب الطلب" },
      ],
    },
    viz: {
      index: "٠٢",
      label: "مجسّم المدخل",
      title: "شوف بابك على واجهة بيتك.",
      body: "ارفع صورة لواجهة بيتك، والموقع يحدّد فتحة الباب تلقائيًا. اختر التصميم، زبّط المقاسات، واضغط على الباب ليُفتح بحركة البيفوت.",
      emptyTitle: "ابدأ بصورة واجهة بيتك",
      emptyBody: "صوّر الواجهة من الأمام قدر الإمكان، ويفضّل أن تظهر فتحة الباب كاملة. أو جرّب على واجهة نموذجية.",
      upload: "ارفع صورة الواجهة",
      change: "تغيير الصورة",
      demo: "جرّب على واجهة نموذجية",
      reset: "إعادة ضبط",
      autoFit: "ثبّت الباب تلقائيًا",
      openDoor: "افتح الباب",
      closeDoor: "أغلق الباب",
      dragHint: "اسحب الباب لتحريكه — اضغط عليه ليُفتح",
      detecting: "جارٍ تحليل الواجهة وتحديد زوايا فتحة الباب بدقة… قد يستغرق حتى ٣٠ ثانية.",
      autoFound: "تم تحديد فتحة الباب تلقائيًا. يمكنك سحب الباب وتعديل المقاسات بحرّية.",
      manualHint: "ما قدرنا نحدّد الفتحة تلقائيًا في هذه الصورة. اسحب الباب إلى موضع المدخل وزبّط المقاس بالمزالج.",
      loadError: "تعذّر قراءة الصورة. جرّب صورة أخرى بصيغة JPG أو PNG.",
      facadeAlt: "صورة واجهة البيت التي رفعها الزائر",
      designsLabel: "اختر التصميم",
      tryOnFacade: "جرّبه على واجهتك",
      options3d: "خيارات ثلاثية الأبعاد ومعايرة",
      openAngleLabel: "زاوية فتح الباب",
      groupApex: "تشطيبات من أعمال APEX",
      groupConcept: "نماذج تصاميم",
      tagApex: "تشطيب من أعمالنا",
      tagConcept: "نموذج تصميم توضيحي",
      heightLabel: "ارتفاع الدرفة",
      widthLabel: "عرض الدرفة",
      calibLabel: "معايرة المقياس على الصورة",
      calibHint: "استخدمها إذا بدا حجم الباب أكبر أو أصغر من الواقع في صورتك.",
      meter: "م",
      send: "أرسل التصميم على واتساب",
      privacy: "الصورة تُحلَّل مرة واحدة لتحديد فتحة الباب فقط، ولا تُخزَّن عندنا ولا تُرفق تلقائيًا بأي رسالة.",
      disclaimer: "العرض تقريبي للاستعراض البصري فقط، ولا يُعتبر مخططًا هندسيًا أو تأكيدًا للمقاسات.",
      studioLabel: "استوديو المدخل",
      studioTitle: "واجهتك… وبابك الجديد.",
      studioHint: "اختر أي تصميم من الأسفل ليظهر فورًا على واجهتك بالمقاسات التي تحدّدها.",
      dimsTitle: "مقاسات الدرفة",
      dimsHint: "حدّد الارتفاع والعرض بالمتر كما تراه مناسبًا لمدخلك.",
      designsCount: "تصميمًا",
      allDesigns: "الكل",
      backToTop: "شاهد الباب على الواجهة",
      showAll: "عرض كل التصاميم",
    },
    gallery: {
      index: "٠١",
      label: "التصاميم",
      title: "مدخل يشبه ذوقك.",
      body: "صور من أبواب نفّذتها APEX. اختر تصميمًا وابدأ الحديث عنه مباشرة.",
      finish: "التشطيب",
      view: "عرض بالحجم الكامل",
      ask: "اسأل عن هذا التصميم",
      conceptTag: "نموذج تصميم",
      seeAll: "شوف كل التصاميم (٥٦ تصميمًا)",
      filterAria: "تصنيف التصاميم",
      close: "إغلاق",
      prev: "السابق",
      next: "التالي",
    },
    video: {
      index: "٠٣",
      label: "فيديو",
      title: "شوف التفاصيل… وشوف الحركة.",
      body: "مقاطع قصيرة من أبواب منفّذة، تُشغّل بضغطة منك.",
      play: "تشغيل الفيديو",
      external: "شاهد الفيديو",
      pause: "إيقاف مؤقت",
      resume: "متابعة",
      mute: "كتم الصوت",
      unmute: "إلغاء الكتم",
      fullscreen: "ملء الشاشة",
    },
    smart: {
      index: "٠٤",
      label: "الدخول الذكي",
      title: "دخول أذكى. راحة كل يوم.",
      body: "اختَر طريقة الدخول المناسبة لاستخدامك، وناقش معنا مواصفات القفل والتجهيزات.",
      note: "تختلف مزايا الدخول حسب موديل القفل المختار.",
      items: [
        { t: "التعرّف على الوجه", d: "فتح سريع دون لمس، حسب موديل القفل." },
        { t: "بصمة الإصبع", d: "دخول مباشر لأفراد العائلة المسجّلين." },
        { t: "رمز دخول سري", d: "بديل عملي عند عدم توفّر البصمة." },
        { t: "مفتاح ميكانيكي احتياطي", d: "خيار احتياطي دائم للطمأنينة." },
      ],
    },
    materials: {
      index: "٠٥",
      label: "التشطيبات",
      title: "اختَر الملمس اللي يكمّل واجهتك.",
      body: "اضغط على أي تشطيب لتشاهد تفصيلًا منه.",
      note: "اختيار التلبيس يعتمد على التصميم، الوزن وملاءمة الاستخدام.",
      realTag: "تفصيل من باب منفّذ",
      sampleTag: "نموذج تلبيس — الصور قيد التحضير",
      sampleHint: "لا نعرض صورة باب لا تمثّل هذا التلبيس فعليًا.",
    },
    pivot: {
      index: "٠٦",
      label: "الحركة",
      title: "حركة سلسة وهادئة.",
      items: [
        { t: "نظام هيدروليكي للتحكّم بالحركة", d: "يُحدّد انسيابية الفتح والإغلاق حسب التجهيز المختار." },
        { t: "إغلاق تدريجي وهادئ", d: "الباب يستقر دون ارتجاج مزعج." },
        { t: "تهدئة حركة الباب", d: "إحساس ثقيل ومتّزن مع كل استخدام." },
      ],
      caption: "تفصيل المحور الأرضي من باب منفّذ.",
    },
    dimensions: {
      index: "٠٧",
      label: "المقاسات",
      title: "حضور بحجم رؤيتك.",
      heightLabel: "ارتفاع الدرفة",
      widthLabel: "عرض الدرفة",
      config: "تكوين بدرفة واحدة بنظام بيفوت",
      note: "المقاسات الخاصة تخضع لدراسة الأبعاد، الوزن، التلبيس، نظام الحركة ومتطلبات التنفيذ.",
      illustrative: "رسم توضيحي — ليس مخططًا هندسيًا",
      meter: "م",
      sliderHeight: "تغيير الارتفاع التوضيحي",
      sliderWidth: "تغيير العرض التوضيحي",
    },
    inquiry: {
      index: "٠٨",
      label: "ابدأ الحديث",
      title: "خلّينا نبدأ من مدخل بيتك.",
      body: "املأ ما تحبّ، والباقي نكمله بالحديث.",
      city: "البلد أو البلدة",
      cityPh: "مثال: نابلس",
      cityErr: "يرجى كتابة اسم البلد لنبدأ الحديث.",
      required: "مطلوب",
      optional: "اختياري",
      finish: "التشطيب المفضل",
      finishNone: "بدون تحديد",
      height: "الارتفاع التقريبي",
      width: "العرض التقريبي",
      project: "نوع المشروع",
      projectNew: "بناء جديد",
      projectReplace: "استبدال باب موجود",
      notes: "ملاحظات إضافية",
      notesPh: "أي تفصيل يساعدنا…",
      submit: "أرسل التفاصيل على واتساب",
      hint: "بعد فتح واتساب، اضغط إرسال وأرفق صورة المدخل إن توفّرت.",
      noPrice: "لا نعرض أسعارًا تلقائية — السعر يُحدّد بعد مراجعة التفاصيل.",
    },
    process: {
      index: "٠٩",
      label: "كيف نعمل",
      title: "أربع خطوات، بلا تعقيد.",
      steps: [
        "شاركنا صورة المدخل والبلد",
        "نناقش التصميم والتجهيزات",
        "نراجع المقاسات ونقدّم عرض السعر",
        "ننسّق التصنيع والتركيب حسب الاتفاق",
      ],
    },
    about: {
      index: "١٠",
      label: "من نحن",
      title: "تصميم يبدأ من تفاصيل بيتك.",
      body: "في APEX DOORS، نعمل على تصنيع أبواب بيفوت ألمنيوم تجمع بين التصميم، التشطيبات وخيارات الاستخدام. نبدأ بفهم مدخل بيتك وذوقك، ثم نناقش المقاسات، التلبيس والتجهيزات المناسبة للمشروع.",
      caption: "من ورشة APEX أثناء تجهيز لوح ديكوري مفرّغ.",
    },
    faq: {
      index: "١١",
      label: "الأسئلة الشائعة",
      title: "أسئلة قبل ما تبدأ.",
      items: [
        {
          q: "كيف أحصل على عرض سعر؟",
          a: "ابعتلنا على واتساب اسم البلد، صورة للمدخل، المقاسات التقريبية والتشطيب المفضل. هذي المعلومات تكفي لنبدأ النقاش ونوصل لعرض سعر مناسب.",
        },
        {
          q: "هل السعر ثابت لكل الأبواب؟",
          a: "لا. السعر يتغيّر حسب المقاسات، نوع التلبيس، القفل والتجهيزات المختارة، ومتطلبات التركيب في موقعك.",
        },
        {
          q: "هل يمكن تركيب الباب بدل باب موجود؟",
          a: "في كثير من الحالات نعم، لكن الأمر يعتمد على فتحة المدخل، الهيكل القائم ونتيجة معاينة التركيب.",
        },
        {
          q: "هل بصمة الوجه والإصبع موجودة بكل موديل؟",
          a: "لا. مزايا الدخول تختلف حسب موديل القفل المختار، ونحدّدها معك أثناء النقاش.",
        },
        {
          q: "ما خيارات التلبيس؟",
          a: "نعمل حاليًا على البورسلان، الحجر، المظهر الخشبي والألواح الديكورية. ملاءمة كل خيار تعتمد على التصميم والوزن والاستخدام.",
        },
        {
          q: "هل يمكن تنفيذ مقاسات كبيرة؟",
          a: "المدى المتوفّر لدرفة الباب هو ارتفاع من ٢ إلى ٩ متر وعرض من ١.٤٠ إلى ٢.٥٠ متر. أي مقاس خاص يخضع لدراسة الأبعاد، الوزن، التلبيس ونظام الحركة ومتطلبات التنفيذ.",
        },
        {
          q: "هل أحتاج مقاسات دقيقة من البداية؟",
          a: "لا. المقاسات التقريبية تكفي لبداية النقاش، أما المقاسات النهائية فتُثبّت قبل التصنيع.",
        },
        {
          q: "ما مناطق الخدمة؟",
          a: "شاركنا اسم بلدك على واتساب لنتأكد من إمكانية القياس والتركيب في منطقتك.",
        },
        {
          q: "كم يستغرق التصنيع والتركيب؟",
          a: "المدة تُحدّد مع عرض السعر وبحسب تفاصيل المشروع والتجهيزات المختارة.",
        },
      ],
    },
    testimonials: {
      label: "آراء العملاء",
      title: "شو بيقولوا عنّا أصحاب البيوت.",
      body: "تجارب عملاء اختاروا باب بيفوت من APEX لمداخل بيوتهم ومشاريعهم.",
      note: "النصوص والصور توضيحية حتى تُستبدل بآراء وصور عملاء حقيقيين.",
    },
    contact: {
      index: "١٢",
      label: "تواصل",
      title: "بابك القادم… خلّينا نختاره سوا.",
      body: "ابعت صورة مدخلك أو تصميم عجبك، واحكيلنا اسم البلد. بنحكي بالتفاصيل، الخيارات وعرض السعر.",
      wa: "احكِ معنا على واتساب",
      call: "اتصل بنا",
    },
    footer: {
      tagline: "APEX DOORS — الفخامة تبدأ من باب الدار.",
      nav: "روابط",
      contact: "تواصل",
      privacy: "الخصوصية",
      rights: "جميع الحقوق محفوظة",
      backHome: "العودة إلى الرئيسية",
    },
    float: {
      aria: "تواصل مع APEX عبر واتساب",
      bubble: "سؤال عن مدخلك؟ احكِ معنا.",
      dismiss: "إخفاء",
      defaultMsg:
        "مرحبًا APEX، شاهدت الموقع وأرغب باختيار باب Pivot لمدخلي. ممكن نتحدث عن التصاميم والأسعار؟",
    },
    privacy: {
      title: "إشعار الخصوصية",
      updated: "هذا الإشعار يصف ما يحدث فعليًا في هذا الموقع.",
      items: [
        {
          h: "نموذج الاستفسار",
          p: "المعلومات التي تكتبها في نموذج الاستفسار تُستخدم فقط لتجهيز رسالة واتساب جاهزة. لا تُحفظ على أي سيرفر لدينا.",
        },
        {
          h: "مجسّم المدخل",
          p: "عند رفع صورة واجهة بيتك، تُرسل الصورة مرة واحدة لخدمة تحليل بصري لتحديد موضع فتحة الباب فقط، ثم تُحذف ولا تُخزَّن على سيرفراتنا. الصورة تبقى معروضة على جهازك ولا تُرفق تلقائيًا بأي رسالة واتساب.",
        },
        {
          h: "الإرسال يبقى بيدك",
          p: "لا تُرسل أي رسالة حتى تضغط إرسال داخل تطبيق واتساب بنفسك. قبل ذلك لا تصلنا أي بيانات.",
        },
        {
          h: "التخزين",
          p: "هذا الموقع يحفظ تفضيل اللغة فقط في متصفحك، ليستعيد اختيارك عند الزيارة القادمة.",
        },
        {
          h: "أدوات التحليل",
          p: "لم تُربط بالموقع أي أدوات تحليل أو بكسل إعلاني من طرفنا. إن أُضيفت لاحقًا سيُحدَّث هذا الإشعار.",
        },
        {
          h: "واتساب",
          p: "عند فتح المحادثة تنطبق سياسة خصوصية واتساب على الرسائل المتبادلة.",
        },
      ],
    },
  },

  en: {
    dir: "ltr",
    langLabel: "AR",
    langSwitchAria: "Switch to Arabic",
    skipToContent: "Skip to content",
    nav: {
      home: "Home",
      designs: "Designs",
      visualizer: "Visualizer",
      features: "Features & finishes",
      about: "About",
      faq: "FAQ",
      contact: "Contact",
      cta: "Design your entrance",
      menuOpen: "Open menu",
      menuClose: "Close menu",
    },
    hero: {
      eyebrow: "Aluminum pivot doors",
      title: ["Luxury begins", "at the door", "of your home."],
      body: "Aluminum pivot doors with designs that reflect your taste, finishes that match your facade, and smart access options for everyday ease.",
      primary: "Choose your door design",
      secondary: "See the doors in motion",
      strip: ["Made to order", "A range of finishes", "Smart lock options"],
      scroll: "Explore",
      imageNote: "An APEX project",
      mute: "Mute video",
      unmute: "Unmute video",
    },
    marquee: "Luxury begins at the door of your home",
    manifesto: {
      label: "APEX DOORS",
      title: "One door. It speaks for the whole house.",
      body: "We manufacture aluminium pivot doors to order: the dimensions, the cladding, the movement system and the way you enter are decided for your entrance alone. Not a catalogue product — a door built to the measure of your facade.",
      facts: [
        { k: "Leaf height", v: "2 – 9 m" },
        { k: "Leaf width", v: "1.40 – 2.50 m" },
        { k: "Finish families", v: "4" },
        { k: "Production", v: "Made to order" },
      ],
    },
    viz: {
      index: "02",
      label: "Entrance visualizer",
      title: "See your door on your own facade.",
      body: "Upload a photo of your facade and the site locates the door opening automatically. Pick a design, adjust the dimensions, and tap the door to swing it open on its pivot.",
      emptyTitle: "Start with a photo of your facade",
      emptyBody: "Shoot the facade as straight-on as you can, ideally with the whole door opening visible. Or try it on a sample facade.",
      upload: "Upload facade photo",
      change: "Change photo",
      demo: "Try a sample facade",
      reset: "Reset",
      autoFit: "Auto-fit door",
      openDoor: "Open the door",
      closeDoor: "Close the door",
      dragHint: "Drag the door to move it — tap it to open",
      detecting: "Analysing the facade and locating the door opening corners precisely… this can take up to 30 seconds.",
      autoFound: "The door opening was located automatically. You can drag the door and adjust the dimensions freely.",
      manualHint: "We could not locate the opening automatically in this photo. Drag the door onto the entrance and adjust the size with the sliders.",
      loadError: "We could not read that image. Please try another JPG or PNG photo.",
      facadeAlt: "Visitor-uploaded photo of a house facade",
      designsLabel: "Choose a design",
      tryOnFacade: "Try it on your facade",
      options3d: "3D options & calibration",
      openAngleLabel: "Door opening angle",
      groupApex: "Finishes from APEX projects",
      groupConcept: "Design concepts",
      tagApex: "Finish from our work",
      tagConcept: "Illustrative design concept",
      heightLabel: "Leaf height",
      widthLabel: "Leaf width",
      calibLabel: "Scale calibration",
      calibHint: "Use this if the door looks larger or smaller than reality in your photo.",
      meter: "m",
      send: "Send this design on WhatsApp",
      privacy: "Your photo is analysed once, only to locate the door opening. It is not stored by us and is never attached to a message automatically.",
      disclaimer: "This preview is approximate and for visual exploration only. It is not an engineering drawing or a confirmation of dimensions.",
      studioLabel: "Entrance studio",
      studioTitle: "Your facade… your new door.",
      studioHint: "Pick any design below and it appears instantly on your facade with the dimensions you set.",
      dimsTitle: "Leaf dimensions",
      dimsHint: "Set the height and width in metres as you see fit for your entrance.",
      designsCount: "designs",
      allDesigns: "All",
      backToTop: "See the door on the facade",
      showAll: "Show all designs",
    },
    gallery: {
      index: "01",
      label: "Designs",
      title: "An entrance that looks like you.",
      body: "Photographs of doors made by APEX. Pick a design and start the conversation about it.",
      finish: "Finish",
      view: "View full screen",
      ask: "Ask about this design",
      conceptTag: "Concept design",
      seeAll: "See all designs (56)",
      filterAria: "Filter designs",
      close: "Close",
      prev: "Previous",
      next: "Next",
    },
    video: {
      index: "03",
      label: "Video",
      title: "See the detail. See the motion.",
      body: "Short clips of completed doors, played only when you choose.",
      play: "Play video",
      external: "Watch the video",
      pause: "Pause",
      resume: "Resume",
      mute: "Mute",
      unmute: "Unmute",
      fullscreen: "Fullscreen",
    },
    smart: {
      index: "04",
      label: "Smart access",
      title: "Smarter entry. Everyday ease.",
      body: "Choose the entry method that suits how you live, and discuss lock specifications and hardware with us.",
      note: "Access features vary depending on the selected lock model.",
      items: [
        { t: "Face recognition", d: "Quick, touch-free entry, depending on the lock model." },
        { t: "Fingerprint", d: "Direct entry for registered family members." },
        { t: "PIN code", d: "A practical alternative when fingerprint is unavailable." },
        { t: "Backup mechanical key", d: "A permanent fallback for peace of mind." },
      ],
    },
    materials: {
      index: "05",
      label: "Finishes",
      title: "Choose the texture that completes your facade.",
      body: "Select any finish to see a detail of it.",
      note: "The cladding choice depends on the design, the weight and suitability for use.",
      realTag: "Detail from a completed door",
      sampleTag: "Finish sample — photography in preparation",
      sampleHint: "We do not show a door photo that does not actually represent this finish.",
    },
    pivot: {
      index: "06",
      label: "Movement",
      title: "Smooth, quiet movement.",
      items: [
        { t: "Hydraulic movement control", d: "Sets how the door opens and closes, based on the selected hardware." },
        { t: "Gradual, quiet closing", d: "The door settles without an abrupt slam." },
        { t: "Damped door motion", d: "A solid, balanced feel with every use." },
      ],
      caption: "Floor pivot detail from a completed door.",
    },
    dimensions: {
      index: "07",
      label: "Dimensions",
      title: "Presence on the scale of your vision.",
      heightLabel: "Leaf height",
      widthLabel: "Leaf width",
      config: "Single-leaf pivot door configurations",
      note: "Custom dimensions are subject to a review of proportions, weight, cladding, movement system and installation requirements.",
      illustrative: "Illustrative drawing — not an engineering drawing",
      meter: "m",
      sliderHeight: "Adjust illustrative height",
      sliderWidth: "Adjust illustrative width",
    },
    inquiry: {
      index: "08",
      label: "Start the conversation",
      title: "Let's start with your entrance.",
      body: "Fill in whatever you like — we'll cover the rest in conversation.",
      city: "City or town",
      cityPh: "e.g. Nablus",
      cityErr: "Please enter your city so we can start the conversation.",
      required: "Required",
      optional: "Optional",
      finish: "Preferred finish",
      finishNone: "No preference",
      height: "Approximate height",
      width: "Approximate width",
      project: "Project type",
      projectNew: "New construction",
      projectReplace: "Replacing an existing door",
      notes: "Additional notes",
      notesPh: "Anything that helps us…",
      submit: "Send the details on WhatsApp",
      hint: "After WhatsApp opens, press send and attach a photo of your entrance if you have one.",
      noPrice: "No automatic pricing — a quote follows a review of your details.",
    },
    process: {
      index: "09",
      label: "How it works",
      title: "Four steps, no complication.",
      steps: [
        "Share a photo of your entrance and your city",
        "We discuss the design and the hardware",
        "We review dimensions and provide a quote",
        "We arrange manufacturing and installation as agreed",
      ],
    },
    about: {
      index: "10",
      label: "About",
      title: "Design that starts with the detail of your home.",
      body: "At APEX DOORS we manufacture aluminum pivot doors that bring together design, finishes and practical access options. We begin by understanding your entrance and your taste, then discuss the dimensions, cladding and hardware suited to the project.",
      caption: "From the APEX workshop while preparing a laser-cut decorative panel.",
    },
    faq: {
      index: "11",
      label: "FAQ",
      title: "Questions before you begin.",
      items: [
        {
          q: "How do I get a quote?",
          a: "Send us your city, a photo of the entrance, approximate dimensions and your preferred finish on WhatsApp. That is enough for us to start the discussion and work towards a suitable quote.",
        },
        {
          q: "Is the price the same for every door?",
          a: "No. The price changes with the dimensions, the cladding, the lock and hardware selected, and the installation requirements at your site.",
        },
        {
          q: "Can the door replace an existing one?",
          a: "In many cases yes, but feasibility depends on the opening, the existing structure and the installation assessment.",
        },
        {
          q: "Are face and fingerprint recognition in every model?",
          a: "No. Access capabilities vary by the selected lock model, and we define them with you during the discussion.",
        },
        {
          q: "What cladding options are available?",
          a: "We currently work with porcelain, stone, wood-look finishes and decorative panels. The suitability of each depends on the design, weight and use.",
        },
        {
          q: "Can you produce large dimensions?",
          a: "The available range for the door leaf is 2 to 9 metres in height and 1.40 to 2.50 metres in width. Any custom size is subject to a review of proportions, weight, cladding, movement system and installation requirements.",
        },
        {
          q: "Do I need exact dimensions from the start?",
          a: "No. Approximate dimensions are enough to begin; final measurements are confirmed before manufacturing.",
        },
        {
          q: "Which areas do you serve?",
          a: "Share the name of your town with us on WhatsApp so we can confirm whether measuring and installation are possible in your area.",
        },
        {
          q: "How long do manufacturing and installation take?",
          a: "Timing is confirmed with the quote, according to the project details and the hardware selected.",
        },
      ],
    },
    testimonials: {
      label: "Testimonials",
      title: "What homeowners say about us.",
      body: "Experiences of clients who chose an APEX pivot door for their homes and projects.",
      note: "Quotes and photos are illustrative until replaced by real client reviews.",
    },
    contact: {
      index: "12",
      label: "Contact",
      title: "Your next door — let's choose it together.",
      body: "Send a photo of your entrance or a design you liked, and tell us your city. We'll talk through the details, the options and the quote.",
      wa: "Talk to us on WhatsApp",
      call: "Call us",
    },
    footer: {
      tagline: "APEX DOORS — luxury begins at the door of your home.",
      nav: "Links",
      contact: "Contact",
      privacy: "Privacy",
      rights: "All rights reserved",
      backHome: "Back to home",
    },
    float: {
      aria: "Contact APEX on WhatsApp",
      bubble: "A question about your entrance? Talk to us.",
      dismiss: "Dismiss",
      defaultMsg:
        "Hello APEX, I saw your website and I would like to choose a pivot door for my entrance. Could we discuss designs and pricing?",
    },
    privacy: {
      title: "Privacy notice",
      updated: "This notice describes what actually happens on this website.",
      items: [
        {
          h: "The inquiry tool",
          p: "Information you type into the inquiry tool is used only to prepare a ready WhatsApp message. It is not stored on any server of ours.",
        },
        {
          h: "The entrance visualizer",
          p: "When you upload a photo of your facade, it is sent once to a vision analysis service purely to locate the door opening, then discarded — it is not stored on our servers. The photo stays displayed on your device and is never attached to a WhatsApp message automatically.",
        },
        {
          h: "Sending stays with you",
          p: "No message is sent until you press send inside WhatsApp yourself. Before that, no data reaches us.",
        },
        {
          h: "Storage",
          p: "This site stores only your language preference in your browser, so your choice is restored on your next visit.",
        },
        {
          h: "Analytics",
          p: "We have not connected any analytics tools or advertising pixels of our own. If that changes, this notice will be updated.",
        },
        {
          h: "WhatsApp",
          p: "Once the chat opens, WhatsApp's own privacy policy applies to the messages exchanged.",
        },
      ],
    },
  },
};
